module.exports = __webpack_public_path__ + "img/citySelect4.0ece4f8c.png";